import request from '@/utils/request'
import axios from 'axios'


class IDaaS {
    constructor() {
    }
    login(args,state) {
        let url =  `/idaas/callback?state=${state}`
        return  request.post(url, {username:args.username,password:args.password})
    }
    app(state) {
        let url =  `/idaas/app?state=${state}`
        return  request.get(url)
    }
    // 获取登录二维码
    getQrCodeImg(connId) {
        return request.get('/idaas/qrcode/'+connId)
    }
  
    // 获取登录二维码
    getQrCodeLogin(state,ticket) {
        return request.post(`/idaas/callback?state=${state}&ticket=${ticket}`,{})
    }
    getCasUserInfo() {
        return axios.create().get(`/cas/getUserInfo`)
    }
    loginCas(state,args) {
        return request.post(`/idaas/callback?state=${state}`,args)
    }
    changePassword(args) {
        return request.put(`/idaas/api/pwd`,args)
    }
    me(){
        return request.get(`/idaas/api/me`)
    }
    binduser(userId,state) {
        let url =  `/idaas/app/bindinguser`
        return  request.post(url, {userId,state})
    }
    auth(args) {
        let url =  `/idaas/app/auth`
        return  request.post(url, {username:args.username,password:args.password})
    }
    scanCallback(ticket) {
		return request.get(`/idaas/api/scan/callback`, {
			params: {
				ticket: ticket
			}
		});
	}
}

let idaas = new IDaaS()
export default idaas